/**
 * BarcodeScannerField.tsx
 *
 * Barcode scanner field component
 */

import React from 'react';
import { BaseFieldProps } from './shared/types';
import { FieldWrapper } from './shared';
import { BarcodeScannerInput } from '../ui/barcode-scanner';

export const BarcodeScannerField: React.FC<BaseFieldProps> = React.memo(({
  fieldConfig,
  mode,
  value,
  onChange,
  errors = [],
  disabled = false,
  hasError = false,
}) => {
  const isPreviewMode = mode === 'preview';
  const isDisabled = disabled || isPreviewMode;

  const handleChange = (newValue: string) => {
    if (isPreviewMode) return;
    onChange(fieldConfig.id, newValue);
  };

  const handleError = (error: string) => {
    console.error('Barcode scanner error:', error);
  };

  return (
    <FieldWrapper
      field={fieldConfig}
      errors={errors}
      hasError={hasError}
      isPreview={isPreviewMode}
    >
      <BarcodeScannerInput
        value={value}
        onChange={handleChange}
        onError={handleError}
        disabled={isDisabled}
      />
    </FieldWrapper>
  );
});

BarcodeScannerField.displayName = 'BarcodeScannerField';
